import { useEffect, useRef, useState } from 'react';
export const useOneWayTimeoutToggle = (states, changingCondition, duration) => {
  const [state, setState] = useState(changingCondition ? states[1] : states[0]);
  const timeoutRef = useRef();
  useEffect(() => {
    if (changingCondition) {
      timeoutRef.current = window.setTimeout(() => {
        setState(states[1]);
      }, duration);
    } else {
      clearTimeout(timeoutRef.current);
      setState(states[0]);
    }
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [changingCondition, duration, states]);
  return state;
};